import { render, staticRenderFns } from "./MenuRealtimePhone.vue?vue&type=template&id=63177f62&scoped=true"
import script from "./MenuRealtimePhone.vue?vue&type=script&lang=js"
export * from "./MenuRealtimePhone.vue?vue&type=script&lang=js"
import style0 from "./MenuRealtimePhone.vue?vue&type=style&index=0&id=63177f62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63177f62",
  null
  
)

export default component.exports